import {
  CardNumberFormatter,
  CepFormatter,
  CpfFormatter,
  CurrencyFormatter,
  DateFormatter,
  PhoneFormatter,
  StringFormatter,
  TimeFormatter,
} from "@phurshell/psiapp-frontend-core/infra";

export const phoneFormatter = new PhoneFormatter();
export const cepFormatter = new CepFormatter();
export const cpfFormatter = new CpfFormatter();
export const currencyFormatter = new CurrencyFormatter();
export const dateFormatter = new DateFormatter();
export const cardNumberFormatter = new CardNumberFormatter();
export const timeFormatter = new TimeFormatter();
export const stringFormatter = new StringFormatter();

export const formatters = {
  phoneFormatter,
  cepFormatter,
  cpfFormatter,
  currencyFormatter,
  dateFormatter,
  cardNumberFormatter,
  timeFormatter,
  stringFormatter,
};
